import React, { useMemo } from 'react';
import { Modal } from 'antd';
import { AutoResizer } from 'react-base-table';
import { useSelector } from 'react-redux';
import { Retry } from '@components/common';
import { Wrapper, StyledBaseTable } from './styled';
import { useFetchConfigChangelog } from '@components/metrics-panel-hz/hooks/alerts/useFetchConfigChangelog';
import { LOG_TABLE_TITLE } from '../constants';
import { configLogColumnHeader, formatRowData } from './utils';
import { aiAlertsDimensionMappingSelector } from '@store/common/selectors';

const product = window.conviva.module || 'EI';

export default function ConfigChangeLogs({ isOpen, toggleOpen }) {
  const { data, isLoading, isFetching } = useFetchConfigChangelog();
  const aiDimensionMapping = useSelector(aiAlertsDimensionMappingSelector);
  const dataLoading = isLoading || isFetching;

  const tableData = useMemo(() => {
    if (dataLoading || !data) return [];

    return formatRowData(data, aiDimensionMapping[product.toLocaleLowerCase()]);
  }, [data, dataLoading]);

  return (
    <Modal width="80vw" title={LOG_TABLE_TITLE} open={isOpen} onCancel={toggleOpen} footer={[]}>
      <Wrapper>
        {dataLoading ? (
          <Retry isLoading={dataLoading} />
        ) : (
          <AutoResizer>
            {({ width, height }) => (
              <StyledBaseTable
                data={tableData}
                columns={configLogColumnHeader}
                headerHeight={50}
                rowHeight={150}
                width={width}
                height={height}
              />
            )}
          </AutoResizer>
        )}
      </Wrapper>
    </Modal>
  );
}
